module.exports = __webpack_public_path__ + "static/media/ImportTemplate.a80fdf08.csv";